import { __decorate } from "tslib";
import { Component } from 'decorators';
import view from './generateInstructionForm.view.html';
let GenerateInstructionFormComponent = class GenerateInstructionFormComponent {
    constructor() {
        this.handlePromptContextChange = (event) => {
            this.onPromptContextChange?.({ event });
        };
    }
    handleClose() {
        this.onClose?.();
    }
    handleGenerate() {
        this.onGenerate?.();
    }
};
GenerateInstructionFormComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: view,
        bindings: {
            sparkleGradientIcon: '<',
            promptContext: '<',
            onPromptContextChange: '&?',
            onClose: '&?',
            onGenerate: '&?',
        },
    })
], GenerateInstructionFormComponent);
export { GenerateInstructionFormComponent };
